import {Injectable} from '@angular/core';
import {ErrorCaseCode, ErrorHandling} from 'app/_interfaces/error-service.interface';
import {Observable, throwError} from 'rxjs';
import {HttpErrorResponse} from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class ErrorHandlingService implements ErrorHandling {
	errorCaseCode: ErrorCaseCode = {
		code400: e => this.code400(e),
		code401: e => this.code401(e)
	};

	constructor() {
	}

	private code400(e: HttpErrorResponse): Observable<HttpErrorResponse> {
			return throwError(e);
	}

	private code401(e: HttpErrorResponse): Observable<HttpErrorResponse> {
			return throwError(e);
	}

	printError(error: HttpErrorResponse, ...args: any): Observable<HttpErrorResponse> {
		try {
			return this.errorCaseCode[`code${error.status}`](error, ...args);
		} catch (e) {
			return this.default(error);
		}
	}

	default(error: HttpErrorResponse): Observable<HttpErrorResponse> {
		return throwError(error);
	}

}
